export function uuid() {
    // 1) Se existir, usa (melhor caso)
    if (typeof window !== "undefined" && window.crypto?.randomUUID) {
        return window.crypto.randomUUID();
    }

    // 2) Fallback RFC4122 v4 (boa o suficiente pro front)
    // usa crypto.getRandomValues se existir, senão Math.random
    const getRandom = () => {
        if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
            const arr = new Uint8Array(1);
            window.crypto.getRandomValues(arr);
            return arr[0];
        }
        return Math.floor(Math.random() * 256);
    };

    const bytes = Array.from({ length: 16 }, getRandom);

    // RFC 4122 version 4
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = bytes.map((b) => b.toString(16).padStart(2, "0")).join("");

    return (
        hex.slice(0, 8) +
        "-" +
        hex.slice(8, 12) +
        "-" +
        hex.slice(12, 16) +
        "-" +
        hex.slice(16, 20) +
        "-" +
        hex.slice(20)
    );
}
